module.exports = __webpack_public_path__ + "static/media/github.a584bb87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/github.svg
// module id = 201
// module chunks = 0